module.exports = __webpack_public_path__ + "static/media/logo-dark.9092684a.svg";